import React, { useState } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from "reactstrap";
import { Trump } from "../assets";

let items = new Array(5).fill(1);
const TemtimonialCarousel = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item, idx) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={idx}
      >
        <div
          className="testimonial mx-auto position-relative"
          style={{ marginTop: 60, marginBottom: 60 }}
        >
          <img
            className="testimonial-avatar position-absolute"
            style={{ top: -60, left: "50%", transform: "translate(-50%)" }}
            src={Trump}
          />
          <h5 className="text-center mt-5 font-weight-bold">John Doe</h5>
          <p className="m-0 mt-4">
            <i style={{ fontWeight: 500 }}>
              I found this platform a while ago and thought the future messages
              were a cool way to let my family know that I love them when I’m
              not here anymore. I’m currently living with stage 4 leukemia and
              my family has been so supportive. Thank you.
            </i>
          </p>
        </div>
      </CarouselItem>
    );
  });
  return (
    <div>
      <Carousel
        activeIndex={activeIndex}
        className="testimonial-carousel"
        next={next}
        previous={previous}
      >
        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />
        {slides}
        <CarouselControl
          direction="prev"
          directionText="Previous"
          onClickHandler={previous}
        />
        <CarouselControl
          direction="next"
          directionText="Next"
          onClickHandler={next}
        />
      </Carousel>
    </div>
  );
};

export default TemtimonialCarousel;
